export const CONTENT_LIST_NAME = 'contentList';
export const CONFIGURATOR_FORM_NAME = 'columnConfigurator';
